import './App.css';
import { useState, useEffect, useCallback } from 'react';
import { fetchJson, API_KEY } from './utils/api';
import NowPlaying from './components/NowPlaying';
import Stats from './components/Stats';
import History from './components/History';

function App() {
  const [status, setStatus] = useState({ primary: '', secondary: '' });
  const [stats, setStats] = useState(null);
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statsLoading, setStatsLoading] = useState(true);
  const [historyLoading, setHistoryLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    try {
      const data = await fetchJson(`/api/plex/arejessandjessiwatchingharrypotter?apiKey=${API_KEY}`);
      setStatus(data);
    } catch (error) {
      console.error('Error fetching status:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch status on mount and poll every 30s
  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000);
    return () => clearInterval(interval);
  }, [fetchStatus]);

  // Fetch stats once on mount
  useEffect(() => {
    (async () => {
      try {
        const data = await fetchJson(`/api/plex/hp/stats?apiKey=${API_KEY}`);
        setStats(data);
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setStatsLoading(false);
      }
    })();
  }, []);

  // Fetch history once on mount (get more for stats calculation)
  useEffect(() => {
    (async () => {
      try {
        const data = await fetchJson(`/api/plex/hp/history?apiKey=${API_KEY}&limit=500`);
        setHistory(data);
      } catch (error) {
        console.error('Error fetching history:', error);
      } finally {
        setHistoryLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="app">
        <div className="loading">
          <div className="loading-spinner"></div>
          <span className="loading-text">Checking...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <section className="section section--hero">
        <div className="hero">
          <h1 className="hero__answer">{status.primary}</h1>
          <div className="hero__divider" />
          <p className="hero__question">
            {status.secondary || "Are Jess & Jessi watching Harry Potter?"}
          </p>
          {status.tertiary && <p className="hero__detail">{status.tertiary}</p>}
          {status.nowPlaying && <NowPlaying data={status.nowPlaying} />}
        </div>
        <div className="scroll-indicator">
          <span>Stats</span>
          <div className="scroll-indicator__arrow" />
        </div>
      </section>

      <section className="section">
        <div className="section__content">
          <Stats data={stats} history={history} loading={statsLoading} />
        </div>
        <div className="scroll-indicator">
          <span>History</span>
          <div className="scroll-indicator__arrow" />
        </div>
      </section>

      <section className="section section--last">
        <div className="section__content">
          <History data={history} loading={historyLoading} />
        </div>
      </section>
    </div>
  );
}

export default App;
